import React, { useState } from "react";
import { Link } from "react-router-dom";
import ReactQuill, { Quill, Mixin, Toolbar } from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useDropzone } from "react-dropzone";

const NewSubjectForm = () => {
  const [title, setTitle] = useState("");
  const [overview, setOverview] = useState("");
  const [picture, setPicture] = useState(null);

  const onDrop = (acceptedFiles) => {
    setPicture(acceptedFiles[0]);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div className="p-6 bg-white rounded-lg shadow-lg m-4 h-auto">
      <div className="container mx-auto px-4 py-8">
        <h1 className="text-3xl font-bold mb-4 text-[#400167] font-satoshi leading-[30px]">
          New Subject
        </h1>
        <div className="mb-4">
          <label
            className="block text-[#400167] text-[16px] font-semibold mb-2"
            htmlFor="title"
          >
            Subject Title
          </label>
          <input
            id="title"
            type="text"
            placeholder="Write course title"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="shadow appearance-none border border-[#400167] rounded w-[684px] py-3 px-3 text-[#9E9E9E] leading-tight focus:outline-none focus:shadow-outline"
          />
        </div>
        <div className="my-10">
          <label
            className="block text-[#400167] text-[16px] font-semibold mb-2"
            htmlFor="overview"
          >
            Subject Overview
          </label>
          <ReactQuill
            id="overview"
            theme="snow"
            value={overview}
            onChange={setOverview}
            className="h-40 w-[684px]"
          />
        </div>
        <div className="my-20">
          <label
            className="block text-[#400167] text-[16px] font-semibold mb-2"
            htmlFor="picture"
          >
            Subject Picture
          </label>
          <div
            {...getRootProps({
              className:
                "border-solid border-2 border-gray-400 rounded py-4 px-4 italic text-[#9E9E9E] cursor-pointer w-[684px]",
            })}
          >
            <input {...getInputProps()} />
            {picture ? <p>{picture.name}</p> : <p>Click to upload</p>}
          </div>
        </div>
        <Link to="/lessons/add-topic-form">
          <button className="bg-[#5002D0] rounded-full w-[480px] h-[60px] hover:bg-purple-700 text-white text-[16px] font-satoshi font-bold py-2 px-4  mt-4">
            Continue to add Topic
          </button>
        </Link>
      </div>
    </div>
  );
};

export default NewSubjectForm;
